export default {
    // This method sends a custom event to the parent window. Avoid sending sensitive data.
    sendEventToParent(type, data) {
        window.parent.postMessage({
            type: type,
            payload: data
          }, '*');
    },

    // Check if the current window is inside an iframe.
    isIframe() {
        return window !== window.parent;
    }
}


// WEBPACK FOOTER //
// ./src/services/iframeUtil.js